import { useState, useContext, createContext, Dispatch, SetStateAction } from 'react'

import { wishesAndExpectations } from '@ana/shared'
import { Form } from '@ana/shared'
import qs from 'query-string'
import { PostAnamnesisResponse } from 'services/api/ana'

import { getCurrentLanguage } from '../services/i18n'

export type Answers = Partial<
  Form & PostAnamnesisResponse['healthAssistantSuccessActionInfoResult'] & { shouldSkipReferral: boolean }
>

type SetAnswersContextType = Dispatch<SetStateAction<Answers>>

export const AnswersContext = createContext<Answers>({})

export const SetAnswersContext = createContext<SetAnswersContextType>(() => {})

type Props = {
  // The context initial values, should be used only to simplify the tests purposes
  initialValues?: Answers
}

const { code: codeFromParams } = qs.parse(window.location.search)
const parsedCode = typeof codeFromParams === 'string' ? codeFromParams : undefined

export const defaultAnswers: Answers = {
  code: parsedCode,
  pdfReference: 'placeholder', // DEPRECATED
  hasFamilyInsurance: false,
  livesOnDifferentAddress: false,
  diseases: [],
  medications: [],
  isPregnant: undefined,
  allergyPass: false,
  wishesAndExpectations: wishesAndExpectations,
  hasCivilServiceAllowance: false,
  hasDentalInsurance: false,
  language: getCurrentLanguage().toUpperCase(),
}

const AnswersProvider: React.FC<React.PropsWithChildren<Props>> = ({ initialValues = defaultAnswers, children }) => {
  const [answers, setAnswers] = useState<Answers>(initialValues)

  return (
    <AnswersContext.Provider value={answers}>
      <SetAnswersContext.Provider value={setAnswers}>{children}</SetAnswersContext.Provider>
    </AnswersContext.Provider>
  )
}

export const useAnswers = (): Answers => {
  const context = useContext(AnswersContext)

  if (context === undefined) {
    throw new Error('useAnswers must be used within AnswersProvider')
  }

  return context
}

export const useSetAnswers = (): SetAnswersContextType => {
  const context = useContext(SetAnswersContext)

  // eslint-disable-next-line no-constant-binary-expression
  if (!context === undefined) {
    throw new Error('useSetAnswers must be used within AnswersProvider')
  }

  return context
}

export default AnswersProvider
